import _ from 'underscore';
import Promise from 'bluebird';

/**
 * The data source configurations.
 * @typedef QueryConfig
 * @type {Object}
 * @property {OrderByConfig} orderby
 *    The sorting parameter.
 * @property {Object} filter
 *    The filter object in MangoDB format.
 * @property {number} skip
 *    The number of item to skip from the query result.
 * @property {number} take
 *    The number of item to take from the query result.
 */

/**
 * Fetching data from the data source
 * @param {DataChainState} state
 * @param {QueryConfig} params
 *    The data source configurations.
 * @return {DataChainState}
 */
function queryProjectionHandler(state, params) {
  const primaryKey = this.primaryKey;

  /**
   * The `GridView` will reload data from the data source.
   * @event GridView#willReload
   */
  this.trigger('willReload');

  return Promise.resolve(this.query(params)).catch(error => ({
    totalCount: 0,
    items: [],
    error: error || new Error('Failed to load grid data'),
  })).then(({ totalCount, items, error }) => {
    /**
     * The `GridView` did reload data from the data source.
     * This event take 2 parameters
     * 1. succeeded (Boolean), true if the data fetch succeeded
     * 2. data|rejection (Object)
     *    * If the data fetch succeeded, pass the fetched data in form of
     *      `{ totalCount, items }`. Where `totalCount` is the server side total
     *      item count, and the items is the array of data items with current
     *      query condition
     *    * If the data fetch failed, pass the rejection object, which is
     *      usually an `Error` object from the data source
     * @event GridView#didReload
     */
    if (error) {
      this.trigger('didReload', false, error);
    } else {
      this.trigger('didReload', true, { totalCount, items });
    }

    return {
      uniqueId: _.uniqueId('grid-data-'),
      items,
      primaryKey,
      totalCount,
    };
  });
}

export const query = {
  name: 'query',
  handler: queryProjectionHandler,
  defaults: {},
};



// WEBPACK FOOTER //
// ./js/vnext/projection/query.js